import { motion } from "framer-motion";
import RFLottie from "../RFLottie";
import loadingAnimation from "./animate.json";

interface Props {
	onMasterClose?: () => void;
}
export default function Loading(props: Props) {
	return (
		<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.25 }}>
			<div
				className="fixed w-full h-full left-0 top-0 flex items-center justify-center z-[2000]"
				onClick={(e) => {
					if (e.target === e.currentTarget) {
						props.onMasterClose?.();
					}
				}}
			>
				<div className="flex items-center justify-center rounded-lg w-20 h-20 bg-white/60 dark:bg-dark/60">
					<RFLottie
						options={{
							loop: true,
							autoplay: true,
							animationData: loadingAnimation,
						}}
						height={80}
						width={80}
					/>
				</div>
			</div>
		</motion.div>
	);
}
